export function OpenSiteIcon() {
    return (<svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="7"
        fill="none"
        viewBox="0 0 7 7"
      >
        <g
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.5"
          clipPath="url(#clip0_35_605)"
        >
          <path d="M2.96 6.464H1.708a.626.626 0 01-.626-.626v-4.38a.626.626 0 01.626-.626H2.96M5.15 5.212l1.565-1.564L5.15 2.083M6.715 3.648H2.96"></path>
        </g>
        <defs>
          <clipPath id="clip0_35_605">
            <path fill="#fff" d="M0.144 -0.107H7.654V7.403H0.144z"></path>
          </clipPath>
        </defs>
      </svg>)
}